/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function GetUsersResponseDataUsersInnerUserAvatarFromJSON(json) {
    return GetUsersResponseDataUsersInnerUserAvatarFromJSONTyped(json, false);
}
export function GetUsersResponseDataUsersInnerUserAvatarFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        url: !exists(json, 'url') ? undefined : json['url']
    };
}
export function GetUsersResponseDataUsersInnerUserAvatarToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        url: value.url
    };
}
